import { Navigate } from 'react-router-dom';
import { useSessionStorage } from '../../../hooks';
import React, { useState } from 'react';
import Signal from '../../../assets/signal.svg';
import downarrow from '../../../assets/downarrow.svg';
import profile from '../../../assets/profile.png';
import {
  Container, FormTitleContainer
  , FormTitle
  , ConnectivityContainer
  , ConnectivityIcon
  , ConnectivityStatus
  , Connected
  , ProfileContainer
  , ProfileBox
  , ProfileName
  , DownArrow
  , Avatar
  , Box
} from './styled';
import { useAppContext } from '../../../AppContext';



export const Header = (props: any) => {
  const [authenticated, setAuthenticated] = useSessionStorage('authenticated');
  const { state, dispatch } = useAppContext();

  if (authenticated)
    return (
      <Container>
        <FormTitleContainer>
          <FormTitle>
          {state.headerTitle}
          </FormTitle>
        </FormTitleContainer>
        <ConnectivityContainer>
          <ConnectivityIcon src={Signal} />
          <ConnectivityStatus>Connected</ConnectivityStatus>
          <Connected />

        </ConnectivityContainer>
        <ProfileContainer>
          <ProfileBox>
            <Box>
              <ProfileName>
                My Account
              </ProfileName>
              <DownArrow src={downarrow} />
              <Avatar src={profile} />
            </Box>
          </ProfileBox>

        </ProfileContainer>
      </Container>
    );
  return <Navigate to='/' replace />;

};
